'use client';

import { useQuality } from '@/components/shared/QualityProvider';
import { useInfoHijack } from '@/hooks/useInfoHijack';

// Client-side mount for the hijack hook. InfoSection itself is an async
// server component and can't call client hooks; this thin wrapper sits
// inside it as a leaf and installs the wheel/touch/keyboard handlers
// against the `.info-section` selector.
//
// Skipped on the low tier — phone scroll is single-finger and any wheel-
// hijacking-like behaviour fights iOS Safari's native momentum + the URL
// bar collapse. Mobile readers get plain vertical scroll between chapters
// instead; the reveal animations still fire on inView.

export function InfoSectionHijack({ stationCount }: { stationCount: number }) {
  const { tier } = useQuality();
  const enabled = tier === 'high' || tier === 'mid';
  useInfoHijack({
    stationCount,
    sectionSelector: '.info-section',
    enabled,
  });
  return null;
}
